var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1213,
    height: 342,
    fill: "none",
    viewBox: "0 0 1213 342",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#668BA6",
    d: "M24 19v303h195.771V109.911H1197V322h11.91V19H24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#595A5A",
    d: "M254.652 294.16h-38.941c-1.539 0-2.811-2.116-2.811-4.678s1.272-4.678 2.811-4.678h38.941c1.539 0 2.81 2.116 2.81 4.678s-1.271 4.678-2.81 4.678z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#99B2C4",
    d: "M1209 18.047H4V39.21h1205V18.047z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7D7D7D",
    d: "M775.541 39.21H156.295V52.24h619.246V39.21z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#99B2C4",
    d: "M219 110.043H24v5.68h195v-5.68zM220 38.992h-1v77h1v-77zM219 183.225H24v6.683h195v-6.683zM219 315.992H24v6.682h195v-6.682zM219 246.992H24v6.682h195v-6.682z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCD8E1",
    d: "M219 104.992H24v5.68h195v-5.68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5ECF0",
    d: "M219 178.173H24v6.683h195v-6.683zM219 241.94H24v6.683h195v-6.683z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#99B2C4",
    d: "M140.751 154.934H101.81c-1.539 0-2.81-2.116-2.81-4.678s1.271-4.678 2.81-4.678h38.941c1.539 0 2.811 2.116 2.811 4.678s-1.272 4.678-2.811 4.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003E6B",
    d: "M136.002 149.142h-29.507c-1.205 0-2.141-1.559-2.141-3.564s.936-3.564 2.141-3.564h29.507c1.204 0 2.141 1.559 2.141 3.564s-.937 3.564-2.141 3.564z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#668BA6",
    d: "M140.751 224.547H101.81c-1.539 0-2.81-2.116-2.81-4.678s1.271-4.678 2.81-4.678h38.941c1.539 0 2.811 2.116 2.811 4.678s-1.272 4.678-2.811 4.678z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#668BA6",
    d: "M136.002 218.755h-29.507c-1.205 0-2.141-1.559-2.141-3.564s.936-3.564 2.141-3.564h29.507c1.204 0 2.141 1.559 2.141 3.564s-.937 3.564-2.141 3.564z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#668BA6",
    d: "M140.751 292.912H101.81c-1.539 0-2.81-2.116-2.81-4.678s1.271-4.678 2.81-4.678h38.941c1.539 0 2.811 2.116 2.811 4.678s-1.272 4.678-2.811 4.678z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#668BA6",
    d: "M136.002 287.12h-29.507c-1.205 0-2.141-1.559-2.141-3.564s.936-3.564 2.141-3.564h29.507c1.204 0 2.141 1.559 2.141 3.564s-.937 3.564-2.141 3.564z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#99B2C4",
    d: "M140.751 85.321H101.81c-1.539 0-2.81-2.116-2.81-4.678 0-2.561 1.271-4.678 2.81-4.678h38.941c1.539 0 2.811 2.117 2.811 4.678 0 2.562-1.272 4.678-2.811 4.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003E6B",
    d: "M136.002 79.53h-29.507c-1.205 0-2.141-1.56-2.141-3.565s.936-3.564 2.141-3.564h29.507c1.204 0 2.141 1.56 2.141 3.564 0 2.005-.937 3.564-2.141 3.564z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B0C3D0",
    d: "M1209 0H22.976L4 18.047h1205V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B1C1C",
    d: "M291.618 315.774l-42.827-2.511-43.096 2.511v15.334l43.042 2.421 42.881-2.421v-15.334z",
    opacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 1213,
    height: 341.529,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/Table.13dac372dcdee5349648ae5e50f22440.svg";
export { ForwardRef as ReactComponent };